import NucleusComponentBase from '@/shared/application/nucleus-component-base';
import { Component } from 'vue-property-decorator';


export default class VisitorLayoutComponent extends NucleusComponentBase {
   
}